
// import React from "react";
// import { Button } from "@mantine/core";
// import styles from "./DashBoardNotificationBox.module.css";
// import { formatDate, formatTime } from "../../utilities/utilities";

// function DashBoardNotificationBox({
//   date,
//   module,
//   notificationText,
//   btnName,
//   onBtnClick,
//   isDeleted,
//   seen,
// }) {
//   return (
//     <div className={`${styles.container} ${!seen ? styles.unseen : ""}`}>
      
//       {/* LEFT */}
//       <div className={styles.left}>
//         <span className={styles.tag}>{module}</span>
//         <span className={styles.text}>{notificationText}</span>
//       </div>

//       {/* RIGHT */}
//       <div className={styles.right}>
        
//         <div className={styles.meta}>
//           <img src="/assets/images/calendar.svg" className={styles.icon} />
//           <span>{formatDate(date)}</span>
//         </div>

//         <div className={styles.meta}>
//           <img src="/assets/images/clock.svg" className={styles.icon} />
//           <span>{formatTime(date)}</span>
//         </div>

//         <Button
//           size="xs"
//           radius="xl"
//           disabled={isDeleted}
//           onClick={onBtnClick}
//           className={styles.btn}
//         >
//           {btnName}
//         </Button>
//       </div>
//     </div>
//   );
// }

// export default DashBoardNotificationBox;
import React from "react";
import { Button } from "@mantine/core";
import styles from "./DashBoardNotificationBox.module.css";
import { formatDate, formatTime } from "../../utilities/utilities";

function DashBoardNotificationBox({
  date,
  module,
  notificationText,
  btnName,
  onBtnClick,
  isDeleted,
  seen,
}) {
  return (
    <div className={`${styles.container} ${!seen ? styles.unseen : ""}`}>
      
      {/* LEFT: Notification Content */}
      <div className={styles.left}>
        <span className={styles.tag}>{module}</span>
        {/* We use a div here for better block-level wrapping */}
        <div className={styles.text}>{notificationText}</div>
      </div>

      {/* RIGHT: Meta info and Action */}
      <div className={styles.right}>
        
        {/* Wrap meta items in a group to keep them together */}
        <div className={styles.metaGroup}>
          <div className={styles.meta}>
            <img src="/assets/images/calendar.svg" alt="cal" className={styles.icon} />
            <span className={styles.metaText}>{formatDate(date)}</span>
          </div>

          <div className={styles.meta}>
            <img src="/assets/images/clock.svg" alt="clock" className={styles.icon} />
            <span className={styles.metaText}>{formatTime(date)}</span>
          </div>
        </div>

        {btnName && (
          <Button
            size="xs"
            radius="xl"
            disabled={isDeleted}
            onClick={onBtnClick}
            className={styles.btn}
          >
            {btnName}
          </Button>
        )}
      </div>
    </div>
  );
}

export default DashBoardNotificationBox;